var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"welcome"},[_c('p',[_c('img',{attrs:{"width":"150","src":require("../assets/logo.png")}})]),_vm._v(" "),_c('h2',{staticClass:"is-title is-bold"},[_c('strong',[_vm._v("E-Weaving 管理平台")])]),_vm._v(" "),_c('p',[_vm._v("E-WEAVING Operations Management Platform")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-192918a0","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/Welcome.vue
// module id = zBR/
// module chunks = 0